import { MemeTemplate } from "@/types/aiAgents";
// Meme Agent - Uses runAgent edge function with SambaNova API

// Popular meme templates with their IDs and names
const POPULAR_MEMES: MemeTemplate[] = [
  {
    id: "181913649",
    name: "Drake Pointing",
    url: "https://i.imgflip.com/30b1gx.jpg",
    width: 1200,
    height: 1200,
    box_count: 2,
  },
  {
    id: "87743020",
    name: "Two Buttons",
    url: "https://i.imgflip.com/1g8my4.jpg",
    width: 600,
    height: 908,
    box_count: 3,
  },
  {
    id: "112126428",
    name: "Distracted Boyfriend",
    url: "https://i.imgflip.com/1ur9b0.jpg",
    width: 1200,
    height: 800,
    box_count: 3,
  },
  {
    id: "131087935",
    name: "Running Away Balloon",
    url: "https://i.imgflip.com/26br.jpg",
    width: 761,
    height: 1024,
    box_count: 2,
  },
  {
    id: "4087833",
    name: "Waiting Skeleton",
    url: "https://i.imgflip.com/2fm6x.jpg",
    width: 298,
    height: 403,
    box_count: 2,
  },
  {
    id: "102156234",
    name: "Mocking Spongebob",
    url: "https://i.imgflip.com/1otk96.jpg",
    width: 502,
    height: 353,
    box_count: 2,
  },
  {
    id: "129242436",
    name: "Change My Mind",
    url: "https://i.imgflip.com/24y43o.jpg",
    width: 482,
    height: 361,
    box_count: 2,
  },
  {
    id: "97984",
    name: "Disaster Girl",
    url: "https://i.imgflip.com/23ls.jpg",
    width: 500,
    height: 375,
    box_count: 2,
  },
  {
    id: "61579",
    name: "One Does Not Simply",
    url: "https://i.imgflip.com/1bij.jpg",
    width: 568,
    height: 335,
    box_count: 2,
  },
  {
    id: "79132341",
    name: "Bike Fall",
    url: "https://i.imgflip.com/1b42wl.jpg",
    width: 500,
    height: 680,
    box_count: 3,
  },
  {
    id: "93895088",
    name: "Expanding Brain",
    url: "https://i.imgflip.com/1jwhww.jpg",
    width: 857,
    height: 1202,
    box_count: 4,
  },
  {
    id: "188390779",
    name: "Woman Yelling At Cat",
    url: "https://i.imgflip.com/345v97.jpg",
    width: 680,
    height: 438,
    box_count: 2,
  },
  {
    id: "114585149",
    name: "Inhaling Seagull",
    url: "https://i.imgflip.com/1w7ygt.jpg",
    width: 1269,
    height: 2825,
    box_count: 4,
  },
  {
    id: "135256802",
    name: "Epic Handshake",
    url: "https://i.imgflip.com/28j0te.jpg",
    width: 900,
    height: 645,
    box_count: 3,
  },
  {
    id: "222403160",
    name: "Bernie I Am Once Again Asking For Your Support",
    url: "https://i.imgflip.com/3oevdk.jpg",
    width: 750,
    height: 750,
    box_count: 2,
  },
  {
    id: "80707627",
    name: "Sad Pablo Escobar",
    url: "https://i.imgflip.com/1c1uej.jpg",
    width: 720,
    height: 709,
    box_count: 3,
  },
  {
    id: "1035805",
    name: "Boardroom Meeting Suggestion",
    url: "https://i.imgflip.com/m78d.jpg",
    width: 500,
    height: 649,
    box_count: 4,
  },
  {
    id: "178591752",
    name: "Tuxedo Winnie The Pooh",
    url: "https://i.imgflip.com/2ybua0.jpg",
    width: 800,
    height: 582,
    box_count: 2,
  },
  {
    id: "27813981",
    name: "Hide the Pain Harold",
    url: "https://i.imgflip.com/gk5el.jpg",
    width: 480,
    height: 601,
    box_count: 2,
  },
  {
    id: "124822590",
    name: "Left Exit 12 Off Ramp",
    url: "https://i.imgflip.com/22bdq6.jpg",
    width: 804,
    height: 767,
    box_count: 3,
  },
];

export const getMemeTemplates = async (): Promise<MemeTemplate[]> => {
  try {
    // Try to fetch from API first, fallback to popular memes
    const response = await fetch("https://api.imgflip.com/get_memes");
    const data = await response.json();

    if (data.success) {
      return data.data.memes.slice(0, 20).map((meme: any) => ({
        id: meme.id,
        name: meme.name,
        url: meme.url,
        width: meme.width,
        height: meme.height,
        box_count: meme.box_count,
      }));
    }
    throw new Error("API failed, using popular memes");
  } catch (error) {
    console.error("Error fetching meme templates, using popular memes:", error);
    return POPULAR_MEMES;
  }
};

export const generateMeme = async (
  templateId: string,
  text0: string = "",
  text1: string = "",
  text2: string = "",
  text3: string = ""
) => {
  try {
    const formData = new FormData();
    formData.append("template_id", templateId);
    formData.append("username", "tehsull98");
    formData.append("password", "cigec55048@fanwn.com");

    // Add all text boxes that have content
    if (text0) formData.append("text0", text0);
    if (text1) formData.append("text1", text1);
    if (text2) formData.append("text2", text2);
    if (text3) formData.append("text3", text3);

    const response = await fetch("https://api.imgflip.com/caption_image", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      return {
        success: true,
        url: data.data.url,
        texts: [text0, text1, text2, text3].filter((t) => t),
      };
    } else {
      return {
        success: false,
        error: data.error_message || "Failed to generate meme",
      };
    }
  } catch (error) {
    console.error("Error generating meme:", error);
    return {
      success: false,
      error: "Meme generation service unavailable",
    };
  }
};

// Auto-show meme templates when meme agent is selected
export const showMemeTemplates = async (): Promise<{
  type: "meme-templates";
  templates: MemeTemplate[];
}> => {
  const templates = await getMemeTemplates();
  return { type: "meme-templates", templates };
};

// Helper to invoke runAgent edge function
const invokeRunAgent = async (agent: string, messages: { role: string; content: string }[], additionalPrompt?: string): Promise<string> => {
  const { supabase } = await import('@/integrations/supabase/client');
  const { data, error } = await supabase.functions.invoke('runAgent', {
    body: {
      agent,
      messages,
      temperature: 0.8,
      stream: false,
      additionalPrompt
    }
  });

  if (error) {
    throw new Error(error.message || 'Failed to fetch from runAgent');
  }

  return data.response || '';
};

// GPT-OSS powered meme generation with AI analysis
export const generateMemeWithAI = async (
  userInput: string,
  isDarkMode?: boolean
): Promise<{ type: "meme-result" | "meme-error"; data: any }> => {
  try {
    const templates = await getMemeTemplates();

    // Build template list for the AI prompt
    const templateList = templates
      .map(
        (template, index) =>
          `${index + 1}. ${template.name} (ID: ${template.id}, ${template.box_count} text boxes)`
      )
      .join("\n");

    const additionalPrompt = `
User input: "${userInput}"

Available meme templates (ONLY THESE ARE AVAILABLE):
${templateList}

IMPORTANT: You MUST choose from the templates listed above. Respond in this exact JSON format:
{
  "templateIndex": <number from 1-${templates.length}>,
  "templateName": "<exact name of selected template from the list above>",
  "texts": [<array of strings, one for each text box of the selected template>],
  "reasoning": "<brief explanation of why this meme fits>"
}

Rules:
1. templateIndex MUST be between 1 and ${templates.length}
2. The texts array must have exactly the right number of strings for the selected template's box_count
3. Make the text funny, relevant, and appropriate for the meme format
4. Keep text concise for meme impact`;

    const responseText = await invokeRunAgent('meme', [
      { role: 'user', content: userInput }
    ], additionalPrompt);

    let selectedTemplate;
    let memeConfig;

    try {
      // Parse JSON from response
      const jsonMatch = responseText.match(/\{[\s\S]*\}/);
      if (!jsonMatch) {
        throw new Error('Failed to parse meme generation response');
      }

      const memeData = JSON.parse(jsonMatch[0]);

      // Validate and get template
      const templateIndex = memeData.templateIndex;
      if (templateIndex >= 1 && templateIndex <= templates.length) {
        selectedTemplate = templates[templateIndex - 1];
      } else {
        selectedTemplate = templates[0]; // Default to first template
      }

      // Ensure texts array has correct number of elements
      const requiredBoxes = selectedTemplate.box_count;
      const texts = memeData.texts || [];
      while (texts.length < requiredBoxes) {
        texts.push("");
      }

      memeConfig = {
        templateName: selectedTemplate.name,
        texts: texts.slice(0, requiredBoxes),
        reasoning: memeData.reasoning || "AI-generated meme"
      };
    } catch (parseError) {
      console.error("Error parsing response:", parseError);
      // Fallback to manual selection
      selectedTemplate = findMemeTemplate(templates, userInput) || templates[0];
      const textData = parseMemeText(userInput);
      memeConfig = {
        templateName: selectedTemplate.name,
        texts: [textData.topText, textData.bottomText].filter((t) => t),
        reasoning: "Fell back to manual selection due to AI response error.",
      };
    }

    // Generate the meme with the correctly identified template ID
    const memeResult = await generateMeme(
      selectedTemplate.id,
      memeConfig.texts[0] || "",
      memeConfig.texts[1] || "",
      memeConfig.texts[2] || "",
      memeConfig.texts[3] || ""
    );

    if (memeResult.success) {
      return {
        type: "meme-result",
        data: {
          memeUrl: memeResult.url,
          templateName: selectedTemplate.name,
        },
      };
    } else {
      return {
        type: "meme-error",
        data: {
          error: memeResult.error || "Failed to generate meme",
        },
      };
    }
  } catch (error) {
    console.error("Error in AI meme generation:", error);
    return {
      type: "meme-error",
      data: {
        error: "Failed to generate meme. Please try again.",
      },
    };
  }
};

// This function is deprecated - components are now handled by React components
export const formatMemeTemplates = (templates: MemeTemplate[]): string => {
  // Return component data instead of HTML
  return JSON.stringify({ type: "meme-templates", templates });
};

export const findMemeTemplate = (
  templates: MemeTemplate[],
  input: string
): MemeTemplate | null => {
  const normalizedInput = input.toLowerCase().trim();

  // Try to find by number first
  const templateNumber = parseInt(normalizedInput);
  if (
    !isNaN(templateNumber) &&
    templateNumber > 0 &&
    templateNumber <= templates.length
  ) {
    return templates[templateNumber - 1];
  }

  // Try to find by name (exact match first, then partial)
  let foundTemplate = templates.find(
    (t) => t.name.toLowerCase() === normalizedInput
  );

  if (!foundTemplate) {
    foundTemplate = templates.find(
      (t) =>
        t.name.toLowerCase().includes(normalizedInput) ||
        normalizedInput.includes(t.name.toLowerCase())
    );
  }

  return foundTemplate || null;
};

export const parseMemeText = (
  input: string
): { topText: string; bottomText: string } => {
  const parts = input.split("|").map((part) => part.trim());
  return {
    topText: parts[0] || "",
    bottomText: parts[1] || "",
  };
};
